// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".noAuth[data-v-c82a0af4]{margin:0!important;top:0;padding-bottom:0;width:100%;height:100%;background:#f8fafc;border-top:0;overflow:none!important}@media(max-width:768px){.noAuth[data-v-c82a0af4]{overflow:scroll!important}.noAuth[data-v-c82a0af4]::-webkit-scrollbar{display:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
